import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * usePutInformasi adalah custom hook yang digunakan untuk memperbarui data informasi di backend.
 * @returns { Object } - Mengembalikan fungsi putZakat, serta status loading dan error.
 */
const usePutInformasi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
    * Fungsi untuk memperbarui data informasi di backend.
   * @param { number } id - ID informasi yang akan diperbarui.
   * @param { string } judul - Judul informasi.
   * @param { string } foto - URL foto informasi.
   * @param { string } deskripsi - Deskripsi informasi.
   * @returns { Promise<Object> } - Mengembalikan data respons dari backend atau error.
   */
  const putInformasi = async (
    id,
    judul,
    deskripsi,
    isi,
    kategori,
    foto,
    tanggal,
    extra = {}
  ) => {
    setLoading(true);
    setError(null);

    try {
      const data = {
        judul,
        deskripsi,
        isi,
        tanggal,
        ...extra,
      };

      // Only include kategori and foto if they have values
      if (kategori !== undefined && kategori !== null && kategori !== '') {
        data.kategori = kategori;
      }
      if (foto !== undefined && foto !== null && foto !== '') {
        data.foto = foto;
      }

      if (!endpoints.informasi || typeof endpoints.informasi.update !== 'function') {
        throw new Error('endpoints.informasi.update is not defined');
      }

      const candidateEndpoints = (Array.isArray(endpoints.informasi.update(id))
        ? endpoints.informasi.update(id)
        : [endpoints.informasi.update(id)]).filter(Boolean);
      let lastError = null;

      for (const endpoint of candidateEndpoints) {
        try {
          const response = await api.put(endpoint, data, {
            headers: {
              'Content-Type': 'application/json',
            },
          });

          return response.data;
        } catch (err) {
          lastError = err;

          if (err?.response?.status !== 404) {
            throw err;
          }
        }
      }

      throw lastError || new Error('Endpoint update informasi tidak ditemukan.');
    } catch (err) {
      console.error('Error updating informasi:', err);
      setError(err.response?.data?.error || err.message || 'Terjadi kesalahan saat memperbarui informasi.');
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { putInformasi, loading, error };
};

export default usePutInformasi;
